import React from 'react'

import VideoRender from '../Common/Video'

const Video = (path) =>
  function (rowData) {
    return rowData[path] ? <VideoRender data={rowData[path]} /> : ''
  }
export default Video
